export default __webpack_public_path__ + "static/media/customer09.eda28a35.jpg";